import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { AppType } from '../../../../store/store';
import css from '../SetPlan.module.scss';
import { Plan } from '../index';
import Button from '../../../../components/UI/Button';
import CheckListItem from '../../../../components/UI/CheckListItem';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';
import { PlanPrices } from '../../../../utils/prices';

interface Props {
  app: AppType;
  plans: PlanPrices
  onInfoClicked: (plan: Plan) => void;
  seeAllPlans: () => void;
  onUpgradeClicked: (plan: Plan) => void;
}

const PlanFlowMaxPlansContainer = ({
  app,
  plans,
  onInfoClicked,
  seeAllPlans,
  onUpgradeClicked
}: Props) => {
  const { loading } = app;
  const { analytics } = useContext(AnalyticsContext);

  return (
    <div className={css.plansFlowContainer}>
      <picture>
        <source
          media="(max-width: 500px)"
          srcSet="../../../static/set-plan-max-banner.svg"
        />
        <source
          media="(min-width: 501px)"
          srcSet="../../../static/set-plan-max-banner-desktop.svg"
        />
        <img
          src="../../../static/set-plan-max-banner.svg"
          alt="Greenlight Max"
          className={css.maxBanner}
          data-testid="max-banner"
        />
      </picture>
      <p className={css.planFlowHeader}>About your plan</p>
      <div className={css.investOption}>
        <img
          src="../../../static/info-icon.svg"
          className={css.investOptionInfo}
          onClick={() => onInfoClicked(Plan.max)}
          data-testid="max-info"
        />
        <h1 data-e2e="upgrade-plans-header">
          Greenlight <span>Max</span>
        </h1>
        <h2
          data-testid="upgrade-plans-subheader"
          data-e2e="upgrade-plans-subheader"
        >
          Covers up to 5 kids
        </h2>
        <div>
          <p className={css.maxOnlyPrice}>${plans.max}/month after trial</p>
          <CheckListItem>
            <p>Debit card & educational app</p>
          </CheckListItem>
          <CheckListItem>
            <p>{'Investing for parents & kids'}</p>
          </CheckListItem>
          <CheckListItem>
            <p>1% Cash Back*</p>
          </CheckListItem>
          <CheckListItem>
            <p>2% Savings Rewards*</p>
          </CheckListItem>
          <CheckListItem>
            <p>Identity theft protection**</p>
          </CheckListItem>
          <CheckListItem>
            <p>Purchase protection</p>
          </CheckListItem>
          <Button
            text="Continue"
            loading={loading}
            onClick={() => {
              analytics.trackEvent('Registration Invest Plan Action', {
                eventProps: {
                  plan: Plan.max,
                  price: plans.max,
                  skipped: false
                }
              });
              onUpgradeClicked(Plan.max);
            }}
            data-e2e="upgrade-max"
          />
        </div>
      </div>
      <p className={css.investSecondaryButton} onClick={seeAllPlans}>
        See all plans
      </p>
      <div className={css.investFooter}>
        <p>
          *See Greenlight's Terms of Service for details on earnings limits and
          how to qualify. Subject to change at any time.
        </p>
        <p>
          **Cell phone and purchase protection provided by Virginia Surety
          Company Inc. Cell phone protection is not available to residents of
          New York.
        </p>
        <p>
          Depending on where you live, you may be charged taxes in addition to
          your subscription price.
        </p>
      </div>
    </div>
  );
};

export default PlanFlowMaxPlansContainer;
